<span class="time-range-text">
  <ftr-date class="time-range-text__start" [date]="timeRange.start" [format]="format"></ftr-date>
  <ng-container *ngIf="isOngoing; else ended"> - now </ng-container>
</span>

<ng-template #ended>
  {{ divider }} <ftr-date class="time-range-text__end" [date]="timeRange.end" [format]="format"></ftr-date>
</ng-template>
